<template>
  <base-dialog v-model="visible">
    <div
      :class="[
        $style.container,
        { [$style.mobileStretch]: mobileStretch },
      ]"
    >
      <div v-if="$slots.hasOwnProperty('title')" :class="$style.title">
        <slot name="title" />
      </div>

      <div ref="content" v-scrollbar="{ id: `scrollbar-${scrollbarId}` }" :class="$style.content">
        <scrollbar-vertical
          :id="`scrollbar-${scrollbarId}`"
          :class="$style.scrollbar"
        />

        <div>
          <slot name="content" />
        </div>
      </div>

      <div v-if="isVisibleFooter" :class="$style.footer">
        <slot name="footer">
          <div :class="[$style.action, $style.submit]">
            <slot name="submit" />
          </div>

          <div :class="[$style.action, $style.cancel]">
            <slot name="cancel" />
          </div>
        </slot>
      </div>
    </div>
  </base-dialog>
</template>

<script>
import { generateRandomString } from 'lib/utils/string';

import BaseDialog from 'molecules/base/Dialog';
import { ScrollbarDirective, ScrollbarVertical } from 'molecules/scrollbar';

export default {
  name: 'DialogTemplate',
  components: {
    BaseDialog,
    ScrollbarVertical,
  },
  directives: {
    scrollbar: ScrollbarDirective,
  },
  props: {
    value: Boolean,
    mobileStretch: Boolean,
  },
  data() {
    return {
      visible: false,
      scrollbarId: generateRandomString(),
    };
  },
  computed: {
    isVisibleFooter() {
      const { footer, submit, cancel } = this.$slots;

      if (this.$validate.isUndefined(submit) && this.$validate.isUndefined(cancel)) {
        return this.$validate.isFixedLengthArray(footer, 1);
      }

      return true;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.visible = val;
      },
    },
    visible: {
      immediate: true,
      handler(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +flexbox
    +flex-direction(column)
    +align-self(flex-end)
    +size(100%, auto)
    position: relative
    max-width: 480px
    max-height: 80vh
    padding: 20px 0
    background-color: var(--color-white)
    z-index: 1000

    +respond-to('medium')
      +align-self(center)
      border-radius: 10px

    &.mobileStretch
      max-height: 100vh
      border-radius: 0

      +respond-to('medium')
        max-height: 80vh
        border-radius: 10px

  .title
    +font-type(semi-bold, 24, 30)
    color: var(---color-white)
    margin-bottom: 20px
    padding: 0 20px

  .content
    +font-type(medium, 14, 20)
    color: var(--color-white)
    position: relative
    padding: 0 20px
    overflow: auto

  .scrollbar
    height: 100%
    position: absolute
    top: 0
    right: 6px

    +respond-to('medium')
      right: 12px

  .footer
    flex: none
    display: flex
    flex-direction: column
    margin-top: 20px
    padding: 0 20px

    +respond-to('small')
      flex-direction: row
      justify-content: space-between

  .action
    flex-grow: 1
    overflow: hidden

    &:not(:last-child)
      margin: 0 0 20px

    +respond-to('small')
      &:not(:last-child)
        margin: 0 20px 0 0

  .submit
    min-width: 230px
</style>
